export const prodUrl = "https://api-v2.3sual.az/";
export const testUrl = "https://api-v2.3sual.az/";
export const localUrl = "https://localhost:5001/";

const normalizeBaseUrl = (url: string): string =>
  url.endsWith("/") ? url : `${url}/`;

const appEnv = (
  process.env.REACT_APP_ENV ||
  process.env.REACT_APP_DEPLOY_ENV ||
  process.env.NODE_ENV ||
  "development"
).toLowerCase();

const defaultApiUrlByEnv: Record<string, string> = {
  production: prodUrl,
  prod: prodUrl,
  test: testUrl,
  development: localUrl,
  dev: localUrl,
  local: localUrl,
};

const fallbackApiUrl = defaultApiUrlByEnv[appEnv] || localUrl;

/**
 * Base URL for API calls.
 * Set REACT_APP_API_URL in the appropriate .env file to override.
 * Falls back based on REACT_APP_ENV/REACT_APP_DEPLOY_ENV/NODE_ENV.
 */
export const apiUrl: string = normalizeBaseUrl(
  process.env.REACT_APP_API_URL || fallbackApiUrl
);

/**
 * Base URL for static/media assets.
 * Set REACT_APP_SITE_URL to load static assets from a different host.
 * Falls back to apiUrl for backward compatibility.
 */
const siteUrl: string = normalizeBaseUrl(process.env.REACT_APP_SITE_URL || apiUrl);

export default siteUrl;
